import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";

const Heading = props => {
  const { type, dataTestId, text, inline } = props;

  if (type < 1 || type > 6) {
    throw new Error(`Invalid type ${type} provided to Heading.`);
  }

  const Tag = inline ? "span" : `h${type}`;
  const headingClass = inline ? `oui-h${type}` : null;
  return (
    <Tag
      data-testid={dataTestId}
      className={gatherClasses(props, headingClass)}
    >
      {text}
    </Tag>
  );
};

Heading.propTypes = {
  type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  inline: PropTypes.bool,
  text: PropTypes.string.isRequired,
  dataTestId: PropTypes.string
};

Heading.defaultProps = {
  type: "6",
  inline: false,
  dataTestId: "orion-heading"
};

Heading.displayName = "OrionHeading";

export default Heading;
